import {http} from './config';
export default {

    update: (id, payload) => {
        return http.put('api/compras/' + id, payload);
    },

    listarCompras: () => {
        return http.get('api/compras');
    },

    save: (compra) => {
        return http.post('api/compras', compra);
    },

    delete: (id) => {
        return http.delete('api/compras/' + id);
    }
}
